import React, { Component } from "react";

import imgCamelLogo from '../../assets/images/main-logo-white.png';
import { addEventNameToEndpoint } from '../../utils/common';

// CSS
import '@uppy/core/dist/style.css';
import '@uppy/url/dist/style.css';
import '@uppy/dashboard/dist/style.css';

import _ from "lodash";
import "./UploadModalContent.scss";

import { initializeUppy } from "../common/UppyCommon";
class UploadModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isShared: true,
      // updateThumbnail: false, // We assume thumb should not be replaced
      urlFiles: [], // file links to be processed via direct import
    };
  }

  componentDidMount() {
    this.onOpenUppyModal();
  }

  getUrlFiles = () => {
    return this.state.urlFiles;
  };

  setUrlFiles = (urlFiles) => {
    this.setState({ urlFiles });
  };
    
  // ////////////////////////////////////////////////////////////////////////////////
  // Open the Uppy modal

  onOpenUppyModal = async () => {
    const tokens = await this.props.Auth.currentSession();
    const isUpdate = this.props.itemId ? true : false;

    const options = {
      id: "uppyUploadModal",
      target: ".uppy-container",
      tenantId: _.get(this.props, "user.tenantId", ""),
      userId: _.get(this.props, "cognitoUser.username", ""),
      itemId: this.props.itemId, // for updates
      tokens: { accessToken: tokens.accessToken.jwtToken, idToken: tokens.idToken.jwtToken },
      cognitoUser: this.props.cognitoUser,
      collectionState: this.props.collectionState,
      // onBeforeUpload: this.handleBeforeUpload,
      items: this.props.items,
      path: this.props.path,
      getUrlFiles: this.getUrlFiles,
      setUrlFiles: this.setUrlFiles,
      Auth: this.props.Auth,
      Analytics: this.props.Analytics,
      onClose: this.props.onClose,
    };
    const uppy = initializeUppy(options);
  };

  render() {
    return (
      <div className="upload-modal-content position-relative">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <button className="position-absolute close-button" onClick={this.props.onClose}>
          ×
        </button>
        <div className="uppy-container"></div>
      </div>
    );
  }
}

export default UploadModalContent;
